<template class="v-application">
  <v-theme-provider root>
    <v-app>
      <v-app-bar app :class="[$route.name == 'EventsCreate' ? 'barra-branca' : 'barra-rosa', 'feathered-edges', 'bottom']" style=" z-index: 9">
        <v-toolbar-title>
          <router-link to="/">
            <v-img
              src="@/assets/mclogoV2.svg"
              class=""
            ></v-img>
          </router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <template>
          <v-app-bar-nav-icon @click="drawer = !drawer" class="d-md-none icon-container">
            <v-icon :class="{ 'rotate-in': drawer, 'rotate-out': !drawer }" style="color: black;" id="menu-icon">
              {{ drawer ? 'mdi-close' : 'mdi-menu' }}
            </v-icon>
          </v-app-bar-nav-icon>
        </template>

          
        <div class="d-none d-md-flex">
        <v-tooltip left color="primary" v-if="$root.session && $root.session.hasPermission && $root.session.hasPermission(['super'])">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" link :to="'/users'" icon>
              <v-icon>mdi-cog</v-icon>
            </v-btn>
          </template>
          <span>Configurações</span>
        </v-tooltip>
        <template >
          <v-btn text class="redirect_button" @click="openHelpModal = true;">
            <span>ajuda</span>
          </v-btn>
        </template>
        <template >
          <router-link :to="{ name: 'TermosECondicoes' }">
          <v-btn text class="redirect_button" :class="{ 'active-link': $route.name === 'TermosECondicoes' }">
            <span>termos e condições</span>
          </v-btn>
          </router-link>
        </template>
        <template >
          <router-link :to="{ name: 'PoliticaDePrivacidade' }">
          <v-btn text class="redirect_button" :class="{ 'active-link': $route.name === 'PoliticaDePrivacidade' }">
            <span>política de privacidade</span>
          </v-btn>
          </router-link>
        </template>
        <template >
          <router-link :to="{ name: 'MatchCalendarsPro' }">
          <v-btn text class="redirect_button" :class="{ 'active-link': $route.name === 'MatchCalendarsPro' }">
            <span>matchcalendars pro</span>
          </v-btn>
        </router-link>
        </template>
        <template >
          <router-link :to="{ name: 'Contacto' }">
          <v-btn text class="redirect_button" :class="{ 'active-link': $route.name === 'Contacto' }">
            <span>contacto</span>
          </v-btn>
        </router-link>
          </template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="logout" text class="redirect_button">
              <span>sair</span>
            </v-btn>
          </template>
          <span>Sair</span>
        </v-tooltip>
      </div>
      </v-app-bar>

      <!-- Drawer para Mobile -->
      <v-navigation-drawer v-model="drawer" app class="d-md-none burger_container" :style="{width: '100%', height: '100vh', paddingTop: '4rem' }">
          <v-list>
            <v-list-item to="/users" v-if="$root.session && $root.session.hasPermission && $root.session.hasPermission(['super'])">
              <v-list-item-content class="redirect_button">configurações</v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content  class="redirect_button" @click="openHelpModal = true;">
                  ajuda
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'MatchCalendarsPro' }">
              <v-list-item-content class="redirect_button">matchcalendars pro</v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'Contacto' }">
              <v-list-item-content class="redirect_button">contacto</v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'TermosECondicoes' }">
              <v-list-item-content class="redirect_button">termos e condições</v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'PoliticaDePrivacidade' }">
              <v-list-item-content class="redirect_button">política de privacidade</v-list-item-content>
            </v-list-item>

            <v-list-item @click="logout">
              <v-list-item-content class="redirect_button">sair</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
      <v-main>
        <v-progress-linear v-if="loading" indeterminate class="global-loader"></v-progress-linear>
        <v-container fluid class="pa-4" style="height: 100%;" v-on="$listeners" v-else>
          <v-row no-gutters style="height: 100%;">
            <v-col cols="12">
              <router-view @read-notifications="notifications = 0"></router-view>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
      <v-footer :class="$route.name == 'EventsCreate' ? 'barra-branca' : 'barra-rosa'" app fixed>
        <span v-if="false" class="body-2"  style="margin: auto; display: block;">Powered By <a target="_blank" href="https://www.dreamdealtech.pt/">Dreamdeal Technologies</a></span>
      </v-footer>
     <Help :show="openHelpModal" @close="openHelpModal = false" />
    </v-app>


  </v-theme-provider>
</template>

  <script>
  import User from "@/api/User.js"
  //import System from "@/api/System.js"
  import Notification from "@/api/Notification.js"
  import Help from '@/views/Help.vue'

  //import DiaryOffline from '@/api/DiaryOffline.js'
  //import { getDiariesOffline, deleteDiaryOffline } from './idb'
  
  export default {
    components: {
      Help
    },
    watch: {
      showMenu: {
        immediate: false,
        handler (val) {
           localStorage['menu-show'] = val;
        },
      },
      showMini: {
        immediate: false,
        handler (val) {
           localStorage['menu-mini'] = val;
        },
      },
      $route: {
          immediate: true,
          handler() {
            if(this.$root.session == undefined){
              return
            }
  
            let theme = this.$root.session.theme;
  
            theme = theme.length == 0 ? this.$themes[0] : theme
            
            this.setTheme(theme);
  
            this.setCssVars();


          }
      },
    },
    data: () => ({
        drawer: false,
        maintenance: false,
        notifications: null,
        newNotification: false,
        showMenu: false,
        openHelpModal: false,
        showMini: false,
        isRender: true,
        user: {},
        items: [],
        loading: true,
        rotateAvatar: false,  // Variável para controlar a rotação
        hover: false, // Variável para controlar o hover
        canRotate: true,
        groupSelectedColor: {},
        admins: [
          ['Management', 'mdi-account-multiple-outline'],
          ['Settings', 'mdi-cog-outline'],
        ],
        cruds: [
          ['Create', 'mdi-plus-outline'],
          ['Read', 'mdi-file-outline'],
          ['Update', 'mdi-update'],
          ['Delete', 'mdi-delete'],
        ],
    }),
    beforeMount(){
      User.getSession(false).then(({data}) => {        
        this.user = User.getInstance(data);  
  
        this.$root.session = this.user;
  
        localStorage['auth'] = 1;

        
        this.listNotifications()

        //this.$router.push({name: 'Events'});
  
        this.setMenu();
  
        this.loading = false;
  
        this.setCssVars();

        localStorage.removeItem('redirectPath');
  
      }).catch((error) => {
  
        console.error(error);
  
        localStorage['auth'] = 0;
        localStorage['redirectPath'] = this.$route.path
  
        this.$router.push('/login');
      });

  
      this.showMini = localStorage['menu-mini'] == "true";
  
      let showMenu = localStorage['menu-show'];
  
      this.showMenu = showMenu != undefined ? showMenu == "true" : true;
  
      this.showMenu = this.showMenu || !this.$vuetify.breakpoint.mdAndDown;

      /*
      if (this.$route.name !== 'Events') {
        this.$router.push({ name: 'Events' });
        
      }
        */
    },
    mounted(){
  
      this.rotateAvatar = false;
      this.canRotate = true;  // Permite rotação logo ao carregar a página
  
    },
    methods:{
      logout() {
        User.logout()
          .then(() => {
            localStorage['auth'] = 0;

            document.cookie.split(";").forEach((c) => {
            document.cookie = c
            .replace(/^ +/, "")
            .replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/");
            });
            document.cookie = 'XSRF-TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

            if (this.$route.name !== 'Login') {
              this.$router.push('/login');
            }
          });
      },
      // Método para iniciar a rotação
      startRotation() {
        if (this.canRotate) {
          this.hover = true; // Ativa o hover
          this.rotateAvatar = true;
          this.canRotate = false;  // Bloqueia a rotação por 1 minuto
  
          // Após 1 minuto, permite nova rotação
          setTimeout(() => {
            this.canRotate = true;
          }, 60000); // 60000 ms = 1 minuto
        }
      },
      // Método para parar a rotação (quando o mouse sai)
      stopRotation() {
        this.hover = false; // Desativa o hover
        this.rotateAvatar = false;
      },
      getVersion(){
              return process.env.VUE_APP_SECRET_VERSION
      },
      listNotifications() {
        Notification.list(1).then(({data}) => {
            this.notifications = data.length
        });
      },
      setCssVars(){
        let color = this.$vuetify.theme.dark ? this.$vuetify.theme.themes.dark.primaryLight
            : this.$vuetify.theme.themes.light.primaryLight;
  
        this.groupSelectedColor = {
          '--group-selected': color,
        };
      },
      toggleTheme(){
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
  
        localStorage['dark-mode'] = Number(this.$vuetify.theme.dark);
      },
  

  
      openMenu(){
  
        if(!this.$vuetify.breakpoint.mdAndDown){
  
          this.showMini = !this.showMini;
  
          return;
        }
  
        this.showMini = false;
  
        this.showMenu = !this.showMenu;
      },

      setMenu() {
        /*
        let menu = [
          {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          has_permission: this.$root.session.hasPermission(["super", "works.read", "diaries.read"]) ,
          exact: true,
          link: "/admin",
          items:[],
        },

       {
          title: "Definições",
          icon: "mdi-cog",
          has_permission: this.$root.session.hasPermission(["super", "roles.read", "users.read", "logs.read", "system_config.read"]),
          link: "",
          group:"admin/settings",
          exact: false,
          items:[

            {
              title: "Gestão de Roles",
              icon: "mdi-shield-account",
              has_permission: this.$root.session.hasPermission(["super", "roles.read"]),
              link: "/admin/settings/roles",
              exact: false,
              items:[],
            },
            {
              title: "Gestão de Utilizadores",
              icon: "mdi-account-multiple",
              has_permission: this.$root.session.hasPermission(["super", "users.read"]),
              link: "/admin/settings/users",
              exact: false,
              items:[],
            },
            {
              title: "Logs",
              icon: "mdi-paperclip",
              link: "/admin/settings/logs",
              has_permission: this.$root.session.hasPermission(["super", "logs.read"]),
              exact: false,
              items:[],
            },
            {
              title: "Configurações gerais",
              icon: "mdi-apple-keyboard-option",
              link: "/admin/settings/system-configurations",
              has_permission: this.$root.session.hasPermission(['super', "system_config.read"]),
              exact: false,
              items:[],
            },
            {
              title: "Gestão de Sistema",
              icon: "mdi-cog",
              link: "/admin/settings/system",
              has_permission: this.$root.session.hasRole(["super"]),
              exact: false,
              items:[],
            },
          ],
        }];
  
        this.items = menu.filter((item) => {
          
          return item.has_permission;
        })*/
      }
    }, 
  };
  </script>
  <style scoped>

body {
  /* MC-315 - Alice Serina - 04/02/2026
      was causing unexpected behaviours due to mix of 
      scrollable and non-scrollable elements
  */
  /* overflow: hidden; */
}

.v-toolbar__content {
  justify-content: space-between;
}

.theme--light.v-btn.v-btn--icon.icon-container[data-v-64778763]  {
  color: rgba(0, 0, 0, 0); 
}

.redirect_button {
  color: #000;
  text-transform: none !important;
  font-weight: 600;
}

.v-application {
  background-color: #E9CFED !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

.barra-rosa {
  background-color: #E9CFED !important;
  color: #fff;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  box-shadow: none !important;
}

.barra-branca {
  background-color: white !important;
  color: #000;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  box-shadow: none !important;
}

.active-link {
  text-decoration: underline;
}

.burger_container {
  background-color: #E9CFED !important;
}

.icon-container {
  position: relative;
}

.v-icon {
  transition: transform 0.3s ease-in-out, opacity 0.2s ease-in-out;
}

.rotate-in {
  transform: rotate(90deg);
  opacity: 1;
}

.rotate-out {
  transform: rotate(0deg);
  opacity: 1;
}
  
  </style>